// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import mushodoPromise from '@webapp-next/lib/request/webapp/mushodo-promise';

export type ChangePlanApiRequest = {
  hostname: string;
  accountType: string;
};

export type ChangePlanApiResponse = {
  success: boolean;
  error?: string;
};

export function changePlan(
  request: ChangePlanApiRequest
): Promise<ChangePlanApiResponse> {
  if (!request.hostname || !request.accountType) {
    throw new Error('Hostname and account type are required to change plan.');
  }

  return mushodoPromise<ChangePlanApiResponse>(
    'changeEditionByHostname',
    request
  );
}
